<template>
  <div class="animated fadeIn">
    <b-row v-if="$route.name === 'PartLog' && $store.getters.isSuper">
      <b-col md="5">
        <b-form-group>
          <b-form-select
            id="auth"
            v-model="curAuth"
            :options="authOptions"
            @change="getPartLogs"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-tabs ref="tabs">
      <b-tab
        v-for="year in Object.keys(contents)"
        :key="year"
        :title="year"
        :active="curYear === year"
        @click="curYear = year"
      >
        <b-row>
          <b-col md="12">
            <b-card>
              <div slot="header">
                <b-row>
                  <b-col
                    cols="8"
                  >
                    <strong>{{ year }} 회의록 - {{ contents[year].modified }} 수정
                      <b-badge :variant="saved ? 'success' : 'danger'">{{ saved ? 'saved' : 'not saved' }}</b-badge>
                    </strong>
                  </b-col>
                  <b-col
                    cols="4"
                    class="text-right"
                  >
                    <b-button
                      variant="primary"
                      @click="saveLog()"
                    >
                      저장하기
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col md="12">
                  <editor
                    :ref="`editor_${year}`"
                    :initial-value="contents[year].content"
                    :options="options"
                    initial-edit-type="wysiwyg"
                    @change="onChange()"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>

import api from '../../api'

import '@toast-ui/editor/dist/toastui-editor.css'
import { Editor } from '@toast-ui/vue-editor'

export default {
  name: 'AdminLog',
  components: { Editor },
  data: function () {
    return {
      authOptions: [],
      curAuth: -1,
      saved: true,
      curYear: '',
      contents: {},
      options: {
        minHeight: '400px',
        language: 'en-US',
        useCommandShortcut: true,
        useDefaultHTMLSanitizer: false,
        usageStatistics: false,
        hideModeSwitch: true,
        toolbarItems: [
          ['heading', 'bold', 'strike'],
          ['hr', 'quote'],
          ['ul', 'ol', 'task', 'indent', 'outdent'],
          ['table', 'image', 'link'],
          ['code', 'codeblock']
        ]
      }
    }
  },
  mounted () {
    if (this.$route.name === 'PartLog' && this.$store.getters.isSuper) {
      // admin은 부서의 회의록을 본다.
      let authList = this.$store.state.AUTHLIST
      Object.keys(authList).forEach(name => {
        this.authOptions.push({ value: authList[name], text: name })
      })
    } else if (this.$store.getters.isSuper || this.$store.getters.isPartAuth) {
      this.curAuth = this.$store.state.AUTH
      this.getLogs()
    } else {
      this.$router.push('/dashboard')
    }
  },
  methods: {
    getPartLogs () {
      if (this.curAuth > 0) {
        this.getLogs()
      }
    },
    getLogs () {
      this.curYear = ''
      this.contents = {}
      api.request('get', '/admin/log/load?auth=' + this.curAuth)
        .then(response => {
          let data = response.data
          Object.keys(data).forEach(year => {
            this.contents[year] = data[year]
          })
          let today = new Date()
          let todayYear = String(today.getFullYear())
          if (!this.contents.hasOwnProperty(todayYear)) {
            this.contents[todayYear] = { year: todayYear, content: '', modified: '' }
          }
          this.curYear = todayYear
          this.$forceUpdate()
        })
        .catch(error => {
          alert('Fail to load', error)
        })
    },
    saveLog () {
      if (this.saved) {
        return
      }
      if (this.curYear === '') {
        alert('No active tab. Something worng')
      }
      let today = new Date()
      let todayMonth = today.getMonth() + 1
      let todayDay = today.getDate()
      let todayYear = today.getFullYear()
      // post arg 세팅
      var postArg = {}
      postArg[this.curYear] = this.contents[this.curYear]
      postArg[this.curYear]['modified'] = todayYear + '.' + todayMonth + '.' + todayDay
      postArg[this.curYear]['auth'] = this.curAuth

      api.request('post', '/admin/log/save', postArg)
        .then(() => {
          this.saved = true
        })
        .catch(error => {
          alert('Fail to save', error)
        })
    },
    onChange () {
      this.contents[this.curYear].content = this.$refs[`editor_${this.curYear}`][0].invoke('getHTML')
      this.saved = false
    }
  }
}
</script>

<style scoped>
.photobox {
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  max-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
  /* IE fix */
#card-chart-01, #card-chart-02 {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
